import { Dialog, DialogTitle, IconButton, DialogContent, DialogActions } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/CloseRounded'
import * as React from 'react'

const CustomerPortalDialog = ({ open, onClose, title, content, footer }: { open: boolean, onClose: () => void, title?: string | React.ReactNode, content: React.ReactNode, footer?: React.ReactNode }) => {

    return (
        <Dialog open={open} onClose={() => onClose()}>
            <DialogTitle>
                {title}
                <IconButton onClick={onClose} style={{ float: 'right', padding: '0' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {content}
            </DialogContent>
            {footer &&
                <DialogActions style={{ padding: '16px 24px' }}>
                    {footer}
                </DialogActions>
            }
        </Dialog >
    )
}

export default CustomerPortalDialog